<div class="content-compact"
[ngClass]="AppSettings.IsRunningInSingularity ? 'content-compact-sso' : ''">
    <div class="consoleHeader d-flex align-items-center"
    [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''">
        <form name="frm" (submit)="SetData()">
            <div class="row align-items-center no-gutters flex-nowrap">
                <div class="col-auto d-flex align-items-center mr-2">
                    <div *ngIf="masterService.LoggedInUserData.Properties.length > 1" ngbDropdown #ddProperty="ngbDropdown" class="w-auto" placement="bottom-left" autoClose="outside" (openChange)="onPropertyOpened($event)">
                        <button type="button" class="btn btn-link firstFilter" ngbDropdownToggle [ngClass]="(RequestModel.Properties.length > 1 ? 'propSelected' : '')"><i class="fas fa-building" title="{{'TITLE.TITLE_SELECT_PROPERTIES' | translate}}"></i></button>
                        <div class="dropdown-menu scrollable-dropdown-menu" ngbDropdownMenu>
                            <div class="dropdown-header" translate>LBL.SELECT_PROPERTIES</div>
                            <div class="px-4">
                                <div class="form-check" *ngFor="let row of masterService.LoggedInUserData.Properties">
                                    <input class="form-check-input" type="checkbox" value="" id="chk_prop_{{row.PropertyId}}" [value]="row.PropertyId" [checked]="idxPropSelectedDropDown(row.PropertyId) >= 0" (change)="onPropertySelected(row.PropertyId, $event)" />
                                    <label class="form-check-label" for="chk_prop_{{row.PropertyId}}">{{row.PropertyName}}</label>
                                </div>
                            </div>
                            <div class="dropdown-divider"></div>
                            <div class="px-4">
                                <button class="btn btn-secondary btn-sm" type="button" (click)="onPropertyChange(); ddProperty.close()" translate>BTN.BTN_SAVE</button>
                            </div>
                            <!--<button class="dropdown-item" *ngFor="let row of masterService.LoggedInUserData.Properties" [ngClass]="{'active': RequestModel.PropertyId == row.PropertyId}" (click)="RequestModel.PropertyId = row.PropertyId">{{row.PropertyName}}</button>-->
                        </div>
                    </div>
                </div>

                <div class="col-auto mr-4">
                    <select class="custom-select" [(ngModel)]="RequestModel.EventId" (change)="SetData()" name="Keyword">
                        <option [ngValue]="null">{{'CMB_DEF.DEF_EVENTMASTER' | translate}}</option>
                        <option *ngFor="let row of lstEventMaster" [ngValue]="row.Id">{{row.Name}}</option>
                    </select>
                </div>

                <div class="col-auto mr-2">
                    <div class="input-group">
                        <input type="text" class="form-control" [(ngModel)]="RequestModel.Keyword" placeholder="{{'PH.PH_SEARCH' | translate }}" name="Keyword" />
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="submit" id="button-addon2">{{'BTN.BTN_SEARCH' | translate}}</button>
                        </div>
                    </div>
                </div>

                <div class="col-auto"><span class="pointer" (click)="SetData()" title="{{'TITLE.TITLE_REFRESH' | translate}}"><i class="fas fa-lg fa-sync-alt"></i></span></div>
            </div>
        </form>
    </div>

    <div class="inbox-body">
        <div class="row align-items-center no-gutters pagerow flex-nowrap sticky-paginator"
        [ngClass]="AppSettings.IsRunningInSingularity ? 'sticky-paginator-sso' : ''">
            <div class="col-auto ml-2" *ngIf="Model && Model.TotalRecords > 0">
                <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="Model.TotalRecords" [pageSize]="RequestModel.PageSize" [(page)]="RequestModel.PageNumber" [boundaryLinks]="true" (pageChange)="onPageChange()"></ngb-pagination>
            </div>
            <div class="col-auto ml-4" *ngIf="Model"><span translate>LBL.TOTAL_RECORDS</span>: <B>{{Model.TotalRecords}}</B></div>
        </div>


        <div *ngIf="IsSubmitting == false && (Model == null || Model.Result == null || Model.Result.length <= 0)" class="px-2"><div class="noRecords"><span translate>LBL.NO_RECORD_FOUND</span></div></div>

        <div class="inbox">
            <div class="grdGrid">
                <sk-wave [isRunning]="IsSubmitting"></sk-wave>

                <div *ngIf="IsSubmitting == false && Model && Model.Result && Model.Result.length > 0">
                    <div class="row grdRow no-gutters pointer" *ngFor="let row of Model.Result" (click)="onMessageClick(row)">
                        <div class="col-auto grdCol"><img src="/Images/EventTypes/n_{{row.EventId}}.png" class="icon" title="{{row.EventDescription}}" /></div>
                        <div class="col-auto grdCol">{{row.CreatedAt | amDateFormat: DateFormat}}</div>
                        <div class="col-auto grdCol">{{row.EventDescription}}</div>
                        <div class="col-auto grdCol">{{row.OwnerName}}</div>
                        <div class="col-auto grdCol">{{row.Subject}}</div>
                        <div class="col grdCol" [ngClass]="row.IsRead == false ? 'font-weight-bold' : ''">{{(row.Message.length > 180) ? (row.Message | slice:0:180) + " ..." : (row.Message)}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<MessageDetail #messageDetail></MessageDetail>



